import { render } from "./TableHeader.vue?vue&type=template&id=52d13c58&scoped=true&ts=true"
import script from "./TableHeader.vue?vue&type=script&lang=ts"
export * from "./TableHeader.vue?vue&type=script&lang=ts"

import "./table-header.scss?vue&type=style&index=0&id=52d13c58&lang=scss&scoped=true"

import exportComponent from "/home/runner/work/orangehrm/orangehrm/installer/client/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-52d13c58"]])

export default __exports__